import PropTypes from 'prop-types';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { Chip, Divider, ListItem, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import ErrorModal from './ErrorModal';
import DatahubIntegrationAccountStatus from './DatahubIntegrationAccountStatus';
import { useTranslation } from 'react-i18next';
export default function DatahubIntegrationAccountCard({ account }) {

  const {t} = useTranslation('datahub-integration')

  const [dialog, setDialog] = useState(false)

  let onClickFunction

  if (account.IsAuthorized) {
    onClickFunction = () => {}
  } else {
    onClickFunction = () => setDialog(true)
  }


  const formatDate = (date) => {
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getFullYear()).slice(-2)}`;
  };
  const chipColor = (date) => {
    const today = new Date()
    const expiryDate = new Date(date);
    if (expiryDate < today) {
      return 'error';
    }

    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(today.getMonth() + 1);

    if (expiryDate <= oneMonthFromNow) {
      return 'warning';
    }

    return 'default';
  }

  const tooltipText = (date) => {
    const today = new Date()
    const expiryDate = new Date(date);
    if (expiryDate < today) {
      return t('daterange.expired');
    }

    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(today.getMonth() + 1);

    if (expiryDate <= oneMonthFromNow) {
      return t('daterange.expires-soon');
    }

    return t('daterange.default');
  }
  return (
    <>
      {/* <ErrorModal open={dialog} handleClose={setDialog} accountId={account.ReCalcAccountId}/> */}
      <ListItem>
        <ListItemIcon>
          <DatahubIntegrationAccountStatus datahubIntegrationAccount={account} />
        </ListItemIcon>
        <ListItemText primary={account.CustomerName} secondary={account.CustomerCVR} />
        <Tooltip title={tooltipText(account.ValidTo)}>
          {account.ValidTo && <Chip label={`${formatDate(account.ValidFrom)}-${formatDate(account.ValidTo)}`} color={chipColor(account.ValidTo)} />}
        </Tooltip>
      </ListItem>
      <Divider />
    </>
  );
}